let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cmc5o")).then(() => parcelRequire('64a9y'));